enum FeatureToggleCode {
    DashboardWidgetDemo = "DashboardWidgetDemo",
    ProductFees = "ProductFees",
    AdHocFees = "AdHocFees",
    ProductBankSettings = "ProductBankSettings",
    ProductCardSettings = "ProductCardSettings",
    ManageCards = "ManageCards",
    Translations = "Translations",
    BuySellFX = "BuySellFX",
    InstitutionPayments = "InstitutionPayments",
    CancelPayments = "CancelPayments",
    HawkAIDemo = "HawkAIDemo",
    TransactionHistoryDemo = "TransactionHistoryDemo",
    CryptocurrencyOverride = "CryptocurrencyOverride",
    AccountToolkit = "AccountToolkit",
    GeneralLedger = "GeneralLedger",
}
export default FeatureToggleCode